import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { SharedService } from "src/app/core";
import { map } from "rxjs/operators";
import { CanActivateFn } from "@angular/router";

export const OnlyCertificationFilingAvailableGuard: CanActivateFn = () => {
    const sharedService = inject(SharedService);
    const router = inject(Router);

    return sharedService.checkIfCertificationFilingAvailable().pipe(
        map((isCertificationAvailable) => {
            return (
                isCertificationAvailable ||
                router.createUrlTree(["dashboard/candidate"])
            );
        })
    );
};
